<template>
    <div class="evaluation">
        <div class="evaluation-top">
            <div class="evaluation-top-title">测评考试</div>
            <div class="evaluation-top-desc">提高文明素质  严肃考风考纪</div>
        </div>
        
        <div class="exam-list">
            <div class="exam-tabs" role="tablist">
                <div
                    class="exam-tab"
                    :class="{ active: activeTab === 'mock' }"
                    role="tab"
                    :aria-selected="activeTab === 'mock'"
                    @click="setActiveTab('mock')"
                >模拟考试</div>
                <div
                    class="exam-tab"
                    :class="{ active: activeTab === 'official' }"
                    role="tab"
                    :aria-selected="activeTab === 'official'"
                    @click="setActiveTab('official')"
                >正式考试</div>
            </div>

            <div v-show="activeTab === 'mock'" class="tab-panel">
                <div class="practice-row">
                    <div class="practice-card">
                        <div class="practice-card-desc">免费通道 · 随时练习</div>
                        <van-button
                            type="info"
                            round
                            block
                            :loading="practiceLoading"
                            @click="handlePracticeTest"
                        >开始模拟考试</van-button>
                    </div>
                </div>
            </div>

            <div
                v-if="officialPanelShown"
                v-show="activeTab === 'official'"
                class="tab-panel tab-panel--official"
            >
                <div v-if="!loading && finished && examList.length === 0" class="empty-state">
                    <van-empty description="暂无考试" />
                </div>
                <van-list
                    v-else
                    v-model="loading"
                    :finished="finished"
                    @load="onLoad"
                >
                    <div class="exam-item" v-for="(item, index) in examList" :key="item.id || index">
                        <div class="exam-content">
                            <div class="icon-wrapper">
                                <van-icon name="records" color="#00BCD4" size="16" />
                            </div>
                            <div class="exam-info">
                                <div class="exam-title">{{ item.title }}</div>
                                <div class="exam-action">
                                    <div class="exam-date">{{ formatDate(item.examBeginTime) }}</div>
                                    <van-button
                                        type="info"
                                        size="small"
                                        round
                                        @click="handleExamAction(item)"
                                    >我要考试</van-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </van-list>
            </div>
        </div>
    </div>
</template>

<script>
    import { getMyToBeTested, getPracticeTest } from '@/api/index.js';
    import moment from 'moment';
    import examBkPay201Mixin from '@/mixins/exam-bk-pay-201.js';
    
    export default {
        components: {},
        mixins: [examBkPay201Mixin],
        props: {},
        data() {
            return {
                activeTab: 'mock', // 'mock' | 'official'
                /** 仅首次切到「正式考试」时挂载列表，避免在模拟考试 Tab 时请求 */
                officialPanelShown: false,
                examList: [],
                pageNum: 1,
                pageSize: 20,
                loading: false,
                finished: false,
                total: 0,
                practiceLoading: false
            };
        },
        watch: {},
        computed: {},
        methods: {
            setActiveTab(tab) {
                this.activeTab = tab
                if (tab === 'official' && !this.officialPanelShown) {
                    this.officialPanelShown = true
                }
                if (tab === 'official') {
                    this.$nextTick(() => {
                        this.ensureOfficialExamList()
                    })
                }
            },
            /**
             * 补拉正式考试列表：van-list 在 v-show/首次挂载时可能不触发 @load，这里保证会请求
             * 仅当无数据且还能加载时拉首屏
             */
            ensureOfficialExamList() {
                if (this.activeTab !== 'official') return
                if (this.loading) return
                if (this.finished) return
                if (this.examList.length > 0) return
                this.loadExamList(false)
            },
            onLoad() {
                this.loadExamList(this.examList.length > 0)
            },
            loadExamList(isLoadMore = false) {
                if (this.loading || this.finished) return;
                
                this.loading = true;
                const data = {
                    pageNum: this.pageNum,
                    pageSize: this.pageSize
                };
                
                getMyToBeTested(data).then(res => {
                    this.loading = false;
                    
                    const records = res.data?.records || [];
                    const total = res.data?.total || 0;
                    
                    if (isLoadMore) {
                        // 追加数据
                        this.examList = [...this.examList, ...records];
                    } else {
                        // 首次加载
                        this.examList = records;
                    }
                    
                    // 判断是否加载完成
                    this.total = total;
                    if (this.examList.length >= total || records.length < this.pageSize) {
                        this.finished = true;
                    } else {
                        this.pageNum++;
                    }
                }).catch(err => {
                    this.loading = false;
                    this.finished = true;
                });
            },
            formatDate(dateStr) {
                if (!dateStr) return '';
                // 格式化日期为：2025年08月26日
                return moment(dateStr).format('YYYY年MM月DD日');
            },
            handleExamAction(item) {
                // 开始考试 - 跳转到考试详情页
                // 将 notice 存储到 Vuex（时间统计在 startQuiz 接口中统一处理）
                if (item.notice) {
                    this.$store.commit('setExamNotice', item.notice);
                }
                this.$router.push({ 
                    path: '/exam-detail', 
                    query: { 
                        id: item.id,
                        title: item.title
                    } 
                });
            },
            /** 模拟试卷补考下单时 testPaperId 固定为 0 */
            applyPracticeSession(res) {
                const d = res.data
                if (!d) {
                    this.$toast('暂无可用的模拟考试')
                    return
                }
                if (d.answerId == null || d.answerId === '') {
                    this.$toast.fail('未获取到答卷信息')
                    return
                }
                const topicList = d.topicList
                if (!topicList || !Array.isArray(topicList) || topicList.length === 0) {
                    this.$toast.fail('未获取到题目')
                    return
                }
                const remainingTotalSeconds = Number(d.remainingTotalSeconds)
                if (!Number.isFinite(remainingTotalSeconds)) {
                    this.$toast.fail('未获取到剩余时间')
                    return
                }
                if (d.notice) {
                    this.$store.commit('setExamNotice', d.notice)
                }
                this.$store.commit('setPracticeExamSession', {
                    answerId: d.answerId,
                    remainingTotalSeconds,
                    topicList,
                })
                this.$router.push({ path: '/exam-paper-practice' })
            },
            /** 模拟考试：GET /exam/practiceTest；code 201 与同正式考试：补考支付后再拉取会话 */
            handlePracticeTest() {
                this.practiceLoading = true
                getPracticeTest()
                    .then((res) => this.applyPracticeSession(res))
                    .catch((err) => {
                        if (err && err.code === 201) {
                            return this.handleBkPayAfter201(err, {
                                testPaperId: 0,
                                onPaid: () =>
                                    getPracticeTest().then((res) => this.applyPracticeSession(res)),
                            })
                        }
                        return Promise.reject(err)
                    })
                    .finally(() => {
                        this.practiceLoading = false
                    })
            },
        },
    };
</script>

<style scoped  lang='scss'>
.evaluation {
    min-height: 100%;
    display: flex;
    flex-direction: column;
}

.evaluation-top{
    flex-shrink: 0;
    box-sizing: border-box;
    padding: 90px 15px 0;
    width: 100%;
    height: 300px;
    background: url('~@/assets/image/evaluation-top-bg.png') no-repeat center center;
    background-size: 100% 100%;
    .evaluation-top-title{
        font-size: 24px;
        font-weight: bold;
        color: #fff;
    }
    .evaluation-top-desc{
        font-size: 15px;
        color: #fff;
    }
}

.exam-list {
    flex: 1;
    padding: 0 0 20px;
    margin-top: -80px;
    position: relative;
    z-index: 2;
    background: linear-gradient(to bottom, #C2E5EB, #EEF4F5);
    border-radius: 20px 20px 0 0;
    overflow: hidden;
}

.exam-tabs {
    display: flex;
    background: rgba(194, 229, 235, 0.95);
    border-radius: 20px 20px 0 0;
    padding: 6px 8px 0;
}

.exam-tab {
    flex: 1;
    text-align: center;
    padding: 12px 8px 10px;
    font-size: 16px;
    color: #999;
    position: relative;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    user-select: none;
    transition: color 0.2s;

    &.active {
        color: #333;
        font-weight: 600;
        &::after {
            content: '';
            position: absolute;
            left: 50%;
            bottom: 4px;
            transform: translateX(-50%);
            width: 32px;
            height: 3px;
            background: #ff9800;
            border-radius: 2px;
        }
    }
}

.tab-panel {
    padding: 16px 15px 0;
}

.tab-panel--official {
    min-height: 120px;
}

.practice-row {
    margin-bottom: 0;
}

.practice-card {
    background: #fff;
    border-radius: 12px;
    padding: 16px 14px 14px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.practice-card-desc {
    font-size: 12px;
    color: #999;
    margin-bottom: 12px;
    line-height: 1.4;
}

.exam-item {
    background: #fff;
    border-radius: 12px;
    padding: 14px;
    margin-bottom: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    transition: all 0.3s;
    
    &:active {
        transform: scale(0.98);
    }
    &:last-child {
        margin-bottom: 0;
    }
}

.exam-content {
    flex: 1;
    display: flex;
    align-items: flex-start;
    gap: 12px;
}

.icon-wrapper {
    width: 24px;
    height: 24px;
    background: rgba(0, 188, 212, 0.1);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.exam-info {
    flex: 1;
    min-width: 0;
}

.exam-title {
    font-size: 16px;
    color: #333;
    font-weight: 500;
    margin-bottom: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.exam-action {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .exam-date {
        font-size: 13px;
        color: #999;
    }
    .van-button {
        padding: 0 12px;
        height: 26px;
        line-height: 26px;
        font-size: 12px;
    }
}

.empty-state {
    padding: 60px 20px;
    text-align: center;
}
</style>